import { render, staticRenderFns } from "./ListViewSkeleton.vue?vue&type=template&id=4b01de66&scoped=true"
import script from "./ListViewSkeleton.vue?vue&type=script&lang=js"
export * from "./ListViewSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListViewSkeleton.vue?vue&type=style&index=0&id=4b01de66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01de66",
  null
  
)

export default component.exports